import React from "react";
import { Col, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

import { selectLeague } from "../../../../features/clubhouse/clubhouseSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { TEAM_LOGO_URL } from "../../../../lib/globals";

const LeagueInfo = (): React.JSX.Element => {
    const league = useAppSelector(selectLeague);
    const teams = league?.teams ? [...league?.teams] : [];

    return (
        <Col md={11}>
            <Table
                className="clubhouseLeagueTable"
                striped
                responsive
                data-testid="clubhouseLeagueTable"
            >
                <thead>
                    <tr>
                        <th></th>
                        <th>Team</th>
                        <th></th>
                        <th>Coach</th>
                    </tr>
                </thead>
                <tbody>
                    {teams
                        ?.sort((a, b) => a.name.localeCompare(b.name))
                        .map(t => (
                            <tr key={t.id}>
                                <td>
                                    {t.logo && (
                                        <img
                                            src={`${TEAM_LOGO_URL}${t.logo}`}
                                            alt={`${t.name} logo`}
                                            className="teamLogo img-fluid"
                                        />
                                    )}
                                </td>
                                <td>{t.name}</td>
                                <td>
                                    <Link
                                        to={`/coachs-clubhouse/team/${t.id}/roster`}
                                    >
                                        view roster
                                    </Link>
                                    <br />
                                    <Link
                                        to={`/coachs-clubhouse/team/${t.id}/pitch-counts`}
                                    >
                                        view pitch counts
                                    </Link>
                                </td>
                                <td>
                                    {t.coach.firstName} {t.coach.lastName}
                                    <br />
                                    <a href={`mailto:${t.coach.email}`}>
                                        {t.coach.email}
                                    </a>
                                    <br />
                                    tel: {t.coach.phone}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </Col>
    );
};

export default LeagueInfo;
